import React from 'react';

import FuildImage from '../DecalLaptop/FuildImage.jsx';

import DecalLaptopProduct from '../DecalLaptop/DecalLaptopProduct.jsx';

const DecalLaptop = () => {


  return (
    <div className="decal-laptop">

      <FuildImage />
      <DecalLaptopProduct />


    </div>
  );
};

export default DecalLaptop;